module.exports = __webpack_public_path__ + "img/changeCardBanner.48e6cd9a.png";